<template>
  <tender-form-label :key="index" :label="options.Name" :prop="options.Key" :rules="rules">
    <bear-upload-dialog
      ref="bearUploadDialog"
      :maxLimit="1"
      v-model="form[options.Key]"
      @input="inputChangeHandle"
      :accept="param.accept"></bear-upload-dialog>
  </tender-form-label>
</template>
<script>
import BearUploadDialog from "~@/upload-dialog/src";
import { mixForFormItem } from "../../../js/mixins";
import utils from "../../../js/utils";
import api from "@/common/js/api";
import { h } from "vue";
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
export default {
  name: "FormUploadFileGclqd",
  mixins: [mixForFormItem],
  components: { BearUploadDialog },
  data() {
    return {
      fileLimitLength: 800,
      fileConfig: {
        selectNames: [],
        fileListName: [],
      },
    };
  },
  created() {
    this.setDefaultValue();
  },

  methods: {
    ...mapMutations(["setGclqdOptions"]),
    setDefaultValue() {
      let { form = {}, options = {} } = this;
      utils
        .readyToSetFormItemDefault(form, options)
        .then(() => {
          this.setFormItemValue(options.Value || []);
        })
        .catch(() => null);
    },
    inputChangeHandle(res) {
      let { form = {}, options = {} } = this;
      let { FileConfig = {} } = options;
      this.fileConfig = FileConfig;
      let { fileListName = [] } = this.fileConfig;
      this.clearOptions();
      if (res) {
        api
          .form("/Ufop/ReadExcel", {
            url: res.url,
          })
          .then((response) => {
            if (response.result) {
              let list = response.json.list;

              if (!this.listNameIsOrNot(fileListName, list)) {
                return this.$$alert({
                  message: h("span", null, [
                    h("p", null, "工程量清单格式有误，请核实后重新上传"),
                    h("span", { style: "text-decoration: none;color:red;font-size: 18px;font-weight: bold" }, "推荐下载平台模版"),
                    h(
                      "a",
                      {
                        style: "text-decoration: underline;font-size: 18px;font-weight: bold",
                        href: "/static/excel/工程项目总价表.xlsx",
                        target: "_blank",
                      },
                      "【工程量清单模版】"
                    ),
                  ]),
                });
              } else {
                for (let i = 0; i < list.length; i++) {
                  let keyList = list[i].list[0];
                  if (!this.listListDataIsOrNot(fileListName, list[i].name, keyList)) {
                    return this.$$alert({
                      message: h("span", null, [
                        h("p", null, "工程量清单格式有误，请核实后重新上传"),
                        h("span", { style: "text-decoration: none;color:red;font-size: 18px;font-weight: bold" }, "推荐下载平台模版"),
                        h(
                          "a",
                          {
                            style: "text-decoration: underline;font-size: 18px;font-weight: bold",
                            href: "/static/excel/工程项目总价表.xlsx",
                            target: "_blank",
                          },
                          "【工程量清单模版】"
                        ),
                      ]),
                    });
                  }
                }
              }
              console.log(list);
              let theadName = [],
                theadStr = [],
                isTem = false;
              list.forEach((item) => {
                if (item.list.length > 0) {
                  for (var key in item.list[0]) {
                    if (!this.fileConfig[item.name].includes(key)) {
                      console.log(key);
                      this.$refs["bearUploadDialog"].uploadDlgVisible = false;
                      // this.$refs["PROJECT_PRICE_LIST_ATTACHMENTS"][0].close();
                      // this.form.PROJECT_PRICE_LIST_ATTACHMENTS = [];
                      // this.fileLlist = [];
                      theadName.push(item.name);
                      theadStr.push(key);
                      isTem = true;
                    }
                  }
                }
              });
              if (isTem) {
                theadName = [...new Set(theadName)];
                theadStr = [...new Set(theadStr)];
                return this.$$alert({
                  message: h("span", null, [
                    h("span", { style: "text-decoration: none;color:red;font-size: 18px;font-weight: bold" }, theadName.join("、")),
                    h("span", { style: "text-decoration: none;color:#000;font-size: 18px;font-weight: bold" }, "表格中的"),
                    h(
                      "span",
                      { style: "text-decoration: none;color:red;font-size: 18px;font-weight: bold" },
                      theadStr.join("、") + " 表头格式错误！"
                    ),
                    h("span", { style: "text-decoration: none;color:red;font-size: 18px;font-weight: bold" }, "推荐下载平台模版"),
                    h(
                      "a",
                      {
                        style: "text-decoration: underline;font-size: 18px;font-weight: bold",
                        href: "/static/excel/工程项目总价表.xlsx",
                        target: "_blank",
                      },
                      "【工程量清单模版】"
                    ),
                  ]),
                });
              }

              let name = [],
                keyStr = [],
                isFormat = false;
              list.forEach((item) => {
                item.list.forEach((data) => {
                  for (var key in data) {
                    if (RegExp(/（元）/).test(key)) {
                      if (!/(^[1-9]\d*(\.\d+)?$)|(^0(\.\d+)?$)/.test(data[key])) {
                        this.$refs["bearUploadDialog"].uploadDlgVisible = false;
                        // this.$refs["PROJECT_PRICE_LIST_ATTACHMENTS"][0].close();
                        // this.form.PROJECT_PRICE_LIST_ATTACHMENTS = [];
                        // this.fileLlist = [];
                        name.push(item.name);
                        keyStr.push(key);

                        isFormat = true;
                      }
                    }
                  }
                });
              });
              if (isFormat) {
                name = [...new Set(name)];
                keyStr = [...new Set(keyStr)];
                return this.$$alert({
                  message: h("span", null, [
                    h("span", { style: "text-decoration: none;color:red;font-size: 18px;font-weight: bold" }, name.join("、")),
                    h("span", { style: "text-decoration: none;color:#000;font-size: 18px;font-weight: bold" }, "表格中的"),
                    h("span", { style: "text-decoration: none;color:red;font-size: 18px;font-weight: bold" }, keyStr.join("、") + "列请输入数字"),
                  ]),
                });
              }
              // this.$set(this.form, "PROJECT_PRICE_LIST", [{ name: "无" }].concat(response.json.list));
              form[options.Key] = [res];
              /* 施工增加 无的选项 */
              if (form.type == "施工") {
                form.PROJECT_PRICE_LIST = [{ name: "无" }].concat(response.json.list);
              } else {
                form.PROJECT_PRICE_LIST = response.json.list;
              }
              this.setGclqdOptions(form.PROJECT_PRICE_LIST);
            } else {
              this.$message({
                type: "info",
                message: response.msg,
              });
            }
          });
      }

      this.doValidate();
    },
    listNameIsOrNot(fileListName, list) {
      for (let j = 0; j < fileListName.length; j++) {
        for (let i = 0; i < list.length; i++) {
          if (list[i].name == fileListName[j]) {
            break;
          } else {
            if (i == list.length - 1) {
              this.$refs["bearUploadDialog"].uploadDlgVisible = false;
              // this.$refs["PROJECT_PRICE_LIST_ATTACHMENTS"][0].close();
              // this.form.PROJECT_PRICE_LIST_ATTACHMENTS = [];
              // this.fileLlist = [];
              return false;
            }
          }
        }
      }
      return true;
    },
    listListDataIsOrNot(fileListName, listName, keyList) {
      let that = this;
      for (let i = 0; i < fileListName.length; i++) {
        if (fileListName[i] == listName) {
          let data = that.fileConfig[listName];
          for (let j = 0; j < data.length; j++) {
            let k = 0;
            for (var key in keyList) {
              if (key == data[j]) {
                break;
              } else {
                k++;
                if (k == that.fileConfig[listName].length) {
                  this.$refs["bearUploadDialog"].uploadDlgVisible = false;
                  // that.$refs["PROJECT_PRICE_LIST_ATTACHMENTS"][0].close();
                  // that.form.PROJECT_PRICE_LIST_ATTACHMENTS = [];
                  // that.fileLlist = [];
                  return false;
                }
              }
            }
          }
        }
      }
      return true;
    },

    clearOptions() {
      let { form = {}, options = {} } = this;
      let { selectNames = [] } = this.fileConfig;
      form[options.Key] = [];
      for (let i = 0; i < selectNames.length; i++) {
        form[selectNames[i] + "_SELECT"] = "";
        form[selectNames[i]] = "";
      }
    },
    $$alert(obj) {
      this.$msgbox({
        title: "提示",
        closeOnclickModal: false,
        type: "warning",
        showCancelButton: false,
        confirmButtonText: obj.confirmButtonText || "确定",
        message: obj.message,
      })
        .then(obj.call)
        .catch((e) => {
          console.log(e);
        });
    },
  },
};
</script>
